import { memo } from "react";

import { QuestionPlanDoNotCountKidsAsStock } from "@/components/features/items/edit/plan/_shared/ui/components/kids-policy/do-not-count-kids-as-stock";

import { useDoNotCountKidsAsStock } from "./hooks/use-do-not-count-kids-as-stock/do-not-count-kids-as-stock";

export const QuestionDayTripPlanDoNotCountKidsAsStock = memo(() => {
	const { doNotCountKidsAsStock, onSetDoNotCountKidsAsStock } = useDoNotCountKidsAsStock();

	return (
		<QuestionPlanDoNotCountKidsAsStock
			doNotCountKidsAsStock={doNotCountKidsAsStock}
			onSetDoNotCountKidsAsStock={onSetDoNotCountKidsAsStock}
		/>
	);
});

QuestionDayTripPlanDoNotCountKidsAsStock.displayName = "QuestionDayTripPlanDoNotCountKidsAsStock";
